import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { Button, Modal } from 'semantic-ui-react'

import assign from 'lodash/assign'

import './Message.css'

class Message extends PureComponent {
  onClose = () => {
    this.props.onClose()
  }

  onOptionClick = (event, option) => {
    event.preventDefault()
    this.props.onOptionClick(option)
  }

  render() {
    const { autosize, children, className, message, options, show, title } = this.props

    const actions = options.map((opt) => (
      <Button
        key={opt.text || opt.label || opt.content}
        {...assign(
          {
            compact: true,
            onClick: this.onOptionClick,
            size: 'small',
          },
          opt,
        )}
      />
    ))

    return (
      <Modal
        className={`ModalMessage ${autosize ? 'autosize' : ''} ${className}`}
        closeIcon="close"
        dimmer="blurring"
        onClose={this.onClose}
        open={show}
        size="small"
      >
        {!!title && <Modal.Header>{title}</Modal.Header>}
        <Modal.Content>{children || message}</Modal.Content>
        {actions && actions.length && <Modal.Actions>{actions}</Modal.Actions>}
      </Modal>
    )
  }
}

Message.propTypes = {
  autosize: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element]),
  className: PropTypes.string,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onClose: PropTypes.func,
  onOptionClick: PropTypes.func,
  options: PropTypes.array,
  show: PropTypes.bool,
  title: PropTypes.string,
}

Message.defaultProps = {
  autosize: false,
  children: null,
  className: '',
  message: null,
  onClose: Function.prototype,
  onOptionClick: Function.prototype,
  options: [],
  show: true,
  title: null,
}

export default Message
